import { Debug } from '@carboncopyco/utils';
import { fileServiceApi } from './fileServiceApi';

Debug.extend('demostack-data:api:editorFilesApi');

export interface UploadScreenshotResponse {
  pathToImage: string;
}

export interface BasicResponse {
  link_to_file: string;
}

export interface BasicArgs {
  organizationId: string;
}

interface UploadScreenshotArgs extends BasicArgs {
  fileData: File;
}

export interface UploadCodeSnippetArgs extends BasicArgs {
  snippet: File;
}

export interface UploadTransactionResponseContentArgs extends BasicArgs {
  responseContent: File;
}

export interface UploadTransactionRepresentationFieldsArgs extends BasicArgs {
  representationFields: File;
}

const editorFilesApi = fileServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    uploadImage: builder.mutation<BasicResponse, any>({
      query: ({ organizationId, fileData }) => {
        const formData = new FormData();
        formData.append('file', fileData);
        return {
          url: `/files/editor/images/upload/${organizationId}`,
          method: 'POST',
          body: formData,
        };
      },
    }),
    uploadCodeSnippet: builder.mutation<BasicResponse, UploadCodeSnippetArgs>({
      query: ({ organizationId, snippet }) => {
        const formData = new FormData();
        formData.append('file', snippet);
        return {
          url: `/files/editor/snippets/upload/${organizationId}`,
          method: 'POST',
          body: formData,
        };
      },
    }),

    uploadTransactionResponseContent: builder.mutation<
      BasicResponse,
      UploadTransactionResponseContentArgs
    >({
      query: ({ organizationId, responseContent }) => {
        const formData = new FormData();
        formData.append('file', responseContent);
        return {
          url: `/files/editor/transactions/upload/${organizationId}`,
          method: 'POST',
          body: formData,
        };
      },
    }),

    uploadTransactionRepresentationFields: builder.mutation<
      BasicResponse,
      UploadTransactionRepresentationFieldsArgs
    >({
      query: ({ organizationId, representationFields }) => {
        const formData = new FormData();
        formData.append('file', representationFields);
        return {
          url: `/files/editor/transactions/representation/upload/${organizationId}`,
          method: 'POST',
          body: formData,
        };
      },
    }),

    uploadScreenshot: builder.mutation<
      UploadScreenshotResponse,
      UploadScreenshotArgs
    >({
      query: ({ organizationId, fileData }) => {
        const formData = new FormData();
        formData.append('file', fileData);
        return {
          url: `/files/screenshots/images/upload/${organizationId}`,
          method: 'POST',
          body: formData,
        };
      },
      transformResponse: (response) => {
        return { pathToImage: response.path_to_image };
      },
    }),
  }),
});

export const {
  useUploadImageMutation,
  useUploadScreenshotMutation,
  useUploadCodeSnippetMutation,
  useUploadTransactionResponseContentMutation,
  useUploadTransactionRepresentationFieldsMutation,
} = editorFilesApi;
